var map = {
	"./blob_ci_yaml.js": 61,
	"./blob_ci_yaml.js.es6": 61,
	"./blob_dockerfile_selector.js": 62,
	"./blob_dockerfile_selector.js.es6": 62,
	"./blob_dockerfile_selectors.js": 63,
	"./blob_dockerfile_selectors.js.es6": 63,
	"./blob_file_dropzone.js": 241,
	"./blob_gitignore_selector.js": 242,
	"./blob_gitignore_selectors.js": 243,
	"./blob_license_selector.js": 244,
	"./blob_license_selectors.js": 64,
	"./blob_license_selectors.js.es6": 64,
	"./template_selector.js": 5,
	"./template_selector.js.es6": 5
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;


//////////////////
// WEBPACK FOOTER
// ./blob nonrecursive ^\.\/.*\.(js|es6)$
// module id = 158
// module chunks = 0